import React from 'react';
import { tokenizeWithLinks } from '@coparent/shared/src/utils/linkifyUtils';

const LinkifiedText = ({ text, className = '' }) => {
  if (!text) return null;
  const tokens = tokenizeWithLinks(text);

  return (
    <span className={className} style={{ whiteSpace: 'pre-wrap' }}>
      {tokens.map((tok, i) => {
        if (tok.type === 'url') {
          return (
            <a
              key={i}
              href={tok.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-parent1-600 hover:text-parent1-700 underline break-all"
              onClick={(e) => e.stopPropagation()}
            >
              {tok.value}
            </a>
          );
        }
        return <React.Fragment key={i}>{tok.value}</React.Fragment>;
      })}
    </span>
  );
};

export default LinkifiedText;
